import { C } from "@/theme";

// Simple div-based bar chart matching the mobile aesthetic.
export function BarChart({ data, height = 160, showValues = true }) {
  const max = Math.max(...data.map((d) => d.value), 1);
  const chartH = height - 34;
  return (
    <div>
      <div className="flex items-end gap-1.5" style={{ height: chartH }}>
        {data.map((d, i) => {
          const h = Math.max((d.value / max) * (chartH - 18), d.value > 0 ? 6 : 2);
          return (
            <div key={i} className="flex-1 flex flex-col items-center justify-end">
              {showValues ? <span style={{ color: C.onSurfaceTertiary }} className="text-[11px] font-bold mb-1 tabular-nums">{d.value}</span> : null}
              <div style={{ width: data.length > 6 ? "70%" : "58%", height: h, background: C.brandPrimary }} className="rounded-md transition-all" />
            </div>
          );
        })}
      </div>
      <div className="flex gap-1.5 mt-2">
        {data.map((d, i) => (
          <span key={i} style={{ color: C.muted }} className="flex-1 text-center text-[10px] font-semibold truncate">{d.label}</span>
        ))}
      </div>
    </div>
  );
}

export function DistributionBars({ data }) {
  const max = Math.max(...data.map((d) => d.value), 1);
  return (
    <div className="flex flex-col gap-3">
      {data.map((d, i) => (
        <div key={i} className="flex flex-col gap-1.5">
          <div className="flex justify-between">
            <span style={{ color: C.onSurface }} className="text-[13px] font-semibold">{d.label}</span>
            <span style={{ color: C.onSurfaceTertiary }} className="text-[13px] font-bold tabular-nums">{d.value}</span>
          </div>
          <div style={{ background: C.surfaceTertiary }} className="h-2 rounded-full overflow-hidden">
            <div style={{ width: `${(d.value / max) * 100}%`, background: d.color ?? C.brandSecondary }} className="h-2 rounded-full" />
          </div>
        </div>
      ))}
    </div>
  );
}
